import { default as Image } from '@react/shared/components/Image';

export default function HeroBackgroundImage() {
  return (
    <Image
      layout='raw'
      height={200}
      width={200}
      path='react-assets/agents/agent-hero.png'
      className='object-cover opacity-80'
      alt='A Home to Love'
      priority
      loading='eager'
      data-tp-id='gen-Image-920d6500-97a5-431d-8bc2-f13f706d99a6'
    />
  );
}
